// ── Permission string constants ───────────────────────────────────────────────
// Use these everywhere instead of raw strings to avoid silent typo bugs.

export const PERMISSIONS = {
  // Case files
  CASES_VIEW:    'cases.view',
  CASES_CREATE:  'cases.create',
  CASES_EDIT:    'cases.edit',
  CASES_DELETE:  'cases.delete',

  // Billing & invoices
  BILLING_VIEW:   'billing.view',
  BILLING_CREATE: 'billing.create',
  BILLING_EDIT:   'billing.edit',
  BILLING_DELETE: 'billing.delete',

  // Firm-wide financial visibility. Without this permission, an attorney
  // only sees their own book (their matters, their billable, their flat
  // fees and charges). Admins / Owners / Partners typically have it; junior
  // associates do not. This is separate from billing.view (which controls
  // whether they can see invoices at all on cases they have access to).
  FINANCE_VIEW_FIRM: 'finance.view_firm',

  // Documents
  DOCUMENTS_VIEW:   'documents.view',
  DOCUMENTS_UPLOAD: 'documents.upload',
  DOCUMENTS_DELETE: 'documents.delete',

  // Contacts & clients
  CONTACTS_VIEW:   'contacts.view',
  CONTACTS_EDIT:   'contacts.edit',
  CONTACTS_DELETE: 'contacts.delete',

  // Reports
  REPORTS_VIEW: 'reports.view',

  // Settings
  SETTINGS_VIEW: 'settings.view',
  SETTINGS_EDIT: 'settings.edit',

  // Roles management (admin console)
  ROLES_MANAGE: 'roles.manage',

  // Team management
  TEAM_MANAGE: 'team.manage',
};

// Grouped for the RolesPage permission toggle UI
export const PERMISSION_GROUPS = [
  {
    label: 'Cases',
    permissions: [
      { key: PERMISSIONS.CASES_VIEW,   label: 'View cases' },
      { key: PERMISSIONS.CASES_CREATE, label: 'Create cases' },
      { key: PERMISSIONS.CASES_EDIT,   label: 'Edit cases' },
      { key: PERMISSIONS.CASES_DELETE, label: 'Delete cases' },
    ],
  },
  {
    label: 'Billing',
    permissions: [
      { key: PERMISSIONS.BILLING_VIEW,        label: 'View billing & invoices' },
      { key: PERMISSIONS.BILLING_CREATE,      label: 'Create invoices & record payments' },
      { key: PERMISSIONS.BILLING_EDIT,        label: 'Edit invoices' },
      { key: PERMISSIONS.BILLING_DELETE,      label: 'Delete invoices & payments' },
      { key: PERMISSIONS.FINANCE_VIEW_FIRM,   label: 'View firm-wide revenue & totals (otherwise: only their own book)' },
    ],
  },
  {
    label: 'Documents',
    permissions: [
      { key: PERMISSIONS.DOCUMENTS_VIEW,   label: 'View & download documents' },
      { key: PERMISSIONS.DOCUMENTS_UPLOAD, label: 'Upload documents' },
      { key: PERMISSIONS.DOCUMENTS_DELETE, label: 'Delete documents' },
    ],
  },
  {
    label: 'Contacts & Clients',
    permissions: [
      { key: PERMISSIONS.CONTACTS_VIEW,   label: 'View contacts' },
      { key: PERMISSIONS.CONTACTS_EDIT,   label: 'Create & edit contacts' },
      { key: PERMISSIONS.CONTACTS_DELETE, label: 'Delete contacts' },
    ],
  },
  {
    label: 'Reports',
    permissions: [
      { key: PERMISSIONS.REPORTS_VIEW, label: 'View reports' },
    ],
  },
  {
    label: 'Settings & Admin',
    permissions: [
      { key: PERMISSIONS.SETTINGS_VIEW, label: 'View firm settings' },
      { key: PERMISSIONS.SETTINGS_EDIT, label: 'Edit firm settings' },
      { key: PERMISSIONS.ROLES_MANAGE,  label: 'Manage roles & permissions' },
      { key: PERMISSIONS.TEAM_MANAGE,   label: 'Invite & remove team members' },
    ],
  },
];

export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap(g => g.permissions.map(p => p.key));
